import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Checkbox, Radio, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DropDownOptionProps as Props } from './types';

export const DropDownOption = memo(
  ({
    className,
    label,
    option,
    multiple,
    selected,
    withCheckbox,
    withRadio,
    withCheckmark,
    size,
  }: Props) => {
    const isSelectd = useMemo(() => {
      if (Array.isArray(selected))
        return selected.includes(option.value ?? option.key);
      return selected === option.value || selected === option.key;
    }, [option.key, option.value, selected]);

    return (
      <Styled.Wrapper
        className={classnames('DropDownOption', className)}
        sx={SX.root}
      >
        <Styled.Start>
          {option.startIcon && (
            <Icon name={option.startIcon} size={18} sxx={option.startIconSx} />
          )}
          {withCheckbox && multiple && (
            <Checkbox size={'small'} checked={isSelectd} />
          )}
          {withRadio && !multiple && (
            <Radio size={'small'} checked={isSelectd} />
          )}
          <Typography
            variant="body3"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
            }}
          >
            {label}
          </Typography>
        </Styled.Start>
        <Styled.End>
          {option.metadata && !isSelectd && (
            <Typography variant="body4" color="grey.500">
              {option.metadata}
            </Typography>
          )}
          {option.endIcon && (
            <Icon
              name={option.endIcon}
              color="grey.500"
              size={16}
              sxx={option.endIconSx}
            />
          )}
          {isSelectd && !withRadio && !withCheckbox && withCheckmark && (
            <Icon name="check" color="grey.500" size={20} />
          )}
        </Styled.End>
      </Styled.Wrapper>
    );
  }
);

DropDownOption.displayName = 'DropDownOption';
